/*
 * Atelier "Customize / Made-to-Order" form — lead tracking.
 *
 * The customize form on /pages/the-atelier is the Shopify Forms app
 * (form_id 577341). It renders inside:
 *     <shopify-forms-embed>  ->  <shop-lead-capture>
 * BOTH of which are open shadow roots, and its submit is handled inside
 * that shadow DOM by the app's own JS. A normal theme-level form 'submit'
 * listener therefore never sees it — which is exactly why the customize
 * lead we received on 2026-06-02 produced ZERO analytics events in either
 * RudderStack or Meta.
 *
 * On a genuine submit this fires TWO events:
 *   1. window.rudderTrack('customize_form_submitted', {...})  -> RudderStack CDP
 *   2. fbq('track', 'Lead', {...})                            -> Meta pixel
 *      Shopify's auto-injected Meta pixel only fires PageView + ViewContent,
 *      so mid/bottom-funnel conversions are invisible to the ads team. Firing
 *      'Lead' here makes the customize inquiry a conversion Meta can SEE and
 *      OPTIMISE toward.
 *
 * Detection: 'click' events compose through open shadow boundaries, so a
 * single capture-phase listener on document can see the in-shadow Submit
 * button via event.composedPath(). Verified live: a submit click inside the
 * embed surfaces both the SHOPIFY-FORMS-EMBED host and the submit button in
 * the composed path. We additionally require the phone field to be non-empty
 * so we never fire on empty / validation-failing clicks.
 */
(function () {
  if (typeof window === 'undefined') return;
  if (window.__atelierFormTrack) return; // idempotent
  window.__atelierFormTrack = true;

  var FORM_ID = '577341';
  var DEBOUNCE_MS = 4000;
  var lastFire = 0;

  function isSubmitButton(el) {
    if (!el || el.tagName !== 'BUTTON') return false;
    if (el.type === 'submit') return true;
    return ((el.className || '') + '').indexOf('formSubmitButton') !== -1;
  }

  function findEmbedInPath(path) {
    for (var i = 0; i < path.length; i++) {
      if (path[i] && path[i].tagName === 'SHOPIFY-FORMS-EMBED') return path[i];
    }
    return null;
  }

  // Pierce embed -> nested shadow roots and read the current field state.
  function readFields(embed) {
    var out = { phone: '', description: '', email: '', filled: 0, total: 0 };
    try {
      function scan(root) {
        if (!root) return;
        root.querySelectorAll('input, textarea, select').forEach(function (f) {
          if (f.name === 'h-captcha-response') return; // not a user field
          out.total++;
          var v = (f.value || '').trim();
          if (v) out.filled++;
          if (f.name === 'phone_number') out.phone = v;
          if (f.name === 'custom#description') out.description = v;
          if (f.type === 'email') out.email = v;
        });
        root.querySelectorAll('*').forEach(function (el) {
          if (el.shadowRoot) scan(el.shadowRoot);
        });
      }
      if (embed.shadowRoot) scan(embed.shadowRoot);
    } catch (e) { /* ignore */ }
    return out;
  }

  document.addEventListener('click', function (evt) {
    try {
      var path = evt.composedPath ? evt.composedPath() : [];
      if (!path.length) return;

      var embed = findEmbedInPath(path);
      if (!embed) return; // not the customize form

      var clickedSubmit = false;
      for (var i = 0; i < path.length; i++) {
        if (isSubmitButton(path[i])) { clickedSubmit = true; break; }
      }
      if (!clickedSubmit) return;

      var f = readFields(embed);
      // The phone field is pre-seeded with a country dial code (e.g. "+92 "),
      // so it is never literally empty. Require a real subscriber number —
      // >= 7 digits — so a bare dial code (2 digits) on an untouched form does
      // NOT fire. The app's own validation + captcha catch anything past that.
      var phoneDigits = (f.phone.match(/\d/g) || []).length;
      if (phoneDigits < 7) return;

      var now = Date.now();
      if (now - lastFire < DEBOUNCE_MS) return; // guard double-clicks / re-renders
      lastFire = now;

      var props = {
        form_id: FORM_ID,
        form_name: 'Atelier Customize',
        page: '/pages/the-atelier',
        fields_filled: f.filled,
        fields_total: f.total,
        has_phone: !!f.phone,
        has_description: !!f.description
      };

      // 1) RudderStack CDP — joinable to the rest of this visitor's events.
      if (typeof window.rudderTrack === 'function') {
        window.rudderTrack('customize_form_submitted', props);
      }

      // 2) Meta pixel — a conversion the ads team can see and optimise toward.
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Lead', {
          content_name: 'Atelier Customize Form',
          content_category: 'made-to-order'
        });
      }
    } catch (e) { /* never break the page for analytics */ }
  }, true); // capture phase — clicks compose through the open shadow roots
})();
